<template>
  <div class="divider_container d-flex-row" :class="[!showOr && 'no_show_or']">
    <div class="left_div"></div>
    <h5 class="caps medium-s t-white font-family-2" v-if="showOr">OR</h5>
    <div class="right_div"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    showOr: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
